import React, { useState } from 'react';
import './Header.scss';
import ContactAndOpeningTimes from '../contactInfo/ContactAndOpeningTimes';

type HeaderProps = {
    isSidebarVisible: boolean;
};

export default function Header({ isSidebarVisible }: HeaderProps) {
    const [siteConfig] = useState(JSON.parse(localStorage.getItem('siteConfig') || ""))
    return (
        <div className="container-background">
            <div className="container">
                <div className="header">
                        <div className="header-left">
                            <img
                                className="logo"
                                src={`../../../theme/logos/${siteConfig.activeSite}_logo.png`}
                                alt="logo"
                            />
                        </div>
                    <div className="header-right">
                        <ContactAndOpeningTimes stylingRegion={`header`} isSidebarVisible={isSidebarVisible} />
                    </div>
                </div>
            </div>
        </div>
    );
}